import styled from '@emotion/styled';
import { Flex } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledSavedText = styled.span<{ bgColor?: string }>`
  background-color: ${({ bgColor }) => (bgColor ? `${bgColor}` : `${COLORS.white}`)};
  font-weight: 600;
  padding: 0 4px;
  white-space: pre;
`;

export const StyledSavedWrapper = styled(Flex)`
  font-size: 16px;
  font-size: normal;
  font-weight: 400;

  line-height: 1.63;
  letter-spacing: normal;
  text-align: center;
`;
